import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from 'react-redux';
export const WrapWithReduxStoreContext = (BaseComponent, wrapperProps) => function ReduxStoreWrapper(props) {
    return (_jsx(Provider, { store: wrapperProps.store, children: _jsx(BaseComponent, { ...props }) }));
};
